module.exports = __webpack_public_path__ + "static/img/logistics.d3670fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logistics.png
// module id = f8ry
// module chunks = 44